import ko from "knockout";
import "knockout.validation";
import "flow/koValidationLang/knockout.validation.sv-SE";
import "flow/koValidationLang/knockout.validation.nb-NO";
import "flow/koValidationLang/knockout.validation.fi-FI";
import "flow/koValidationLang/knockout.validation.sv-FI";

export const defaults = {
    insertMessages: true,
    errorsAsTitle: false,
    errorMessageClass: "input-validation-error-message",
    decorateInputElement: true,
    errorElementClass: "input-validation-error",
    parseInputAttributes: false,
    writeInputAttributes: true,
    grouping: {
        deep: true,
        live: true,
        observable: true
    }
};

export function setupValidationDefaults() {
    ko.validation.init(defaults);
}

export function setupValidationLanguage(culture: string) {
    if (culture === "en-GB" || culture === "en") {
        culture = "en-us"; // Already included
    }
    ko.validation.locale(culture);
}
